import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, setToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const ran = useRef(false);
  const [status, setStatus] = useState("Linking your Discord account...");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!code) {
      toast.error("Discord login was cancelled");
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/discord/callback", { code, state });
        setToken(res.data.token);
        await refresh();
        const name = res.data.user?.global_name || res.data.user?.username || "diver";
        toast.success(`Welcome to the reef, ${name}!`);
        if (res.data.joined_guild) {
          toast.success("You've been added to the Discord server");
        }
        navigate("/", { replace: true });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Discord login failed, please try again";
        setStatus(msg);
        toast.error(msg);
        setTimeout(() => navigate("/", { replace: true }), 1500);
      }
    })();
  }, [navigate, refresh]);

  return (
    <main className="relative z-10 min-h-[100svh] flex items-center justify-center px-5">
      <div className="glass-card px-10 py-12 flex flex-col items-center text-center max-w-sm">
        <Loader2 className="w-10 h-10 text-[#7fd0f5] animate-spin" />
        <h1 className="font-display font-bold text-white text-[1.4rem] mt-5">Diving in...</h1>
        <p className="mt-2 text-[#bcd9f2] text-[0.92rem]">{status}</p>
      </div>
    </main>
  );
};

export default AuthCallback;
